<template>
    <div>
        <portal to="page-header">{{ $t('Withdrawals') }}</portal>

        <div class="flex flex-wrap">
            <div class="sm:px-1 md:px-3 lg:px-3 xl:px-3 w-full">
                <div v-if="withdrawals.data.length > 0" class="w-full overflow-hidden shadow-xs">
                    <div class="w-full overflow-x-auto rounded-t">
                        <table class="w-full whitespace-no-wrap">
                            <thead>
                            <tr class="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                                <th class="px-4 py-3">{{ $t('Username') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Balance') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Amount') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Created At') }}</th>
                                <th class="px-4 py-3 text-center">{{ $t('Actions') }}</th>
                            </tr>
                            </thead>
                            <tbody class="bg-gray-200 divide-y dark:divide-gray-700 dark:bg-gray-800">
                            <tr v-for="withdrawal in withdrawals.data" :key="withdrawal.id" class="text-gray-700 dark:text-gray-400">
                                <td class="px-4 py-3">
                                    <inertia-link :href="route('players.show', withdrawal.player.id)">
                                        <span
                                            class="px-2 py-1 font-semibold leading-tight"
                                            :class="{
                                                'text-green-700 bg-green-100': withdrawal.player.active,
                                                'text-red-700 bg-red-100': !withdrawal.player.active
                                            }"
                                        >
                                          {{ withdrawal.player.username }}
                                        </span>
                                    </inertia-link>
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ showFormattedAmount(withdrawal.player.main_wallet.amount, withdrawal.player.main_wallet.currency.code) }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ showFormattedAmount(withdrawal.amount, withdrawal.currency.code) }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ withdrawal.created_at | datetime }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    <div class="flex justify-end space-x-4">
                                        <btn-link class="ml-4" :aria-label="$t('Accept')" :title="$t('Accept')" :href="route('withdrawals.show', withdrawal.id)">
                                            {{ $t('Accept') }}
                                        </btn-link>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="flex justify-between px-4 py-3 text-md font-semibold tracking-wide text-gray-500 rounded-b uppercase border-t dark:border-gray-700 bg-gray-50 sm:grid-cols-9 dark:text-gray-400 dark:bg-gray-800">
                <span class="flex items-center col-span-3">
                  {{ withdrawals.from }} - {{ withdrawals.to }} {{ $t('of') }} {{ withdrawals.total }}
                </span>
                        <span class="col-span-2"></span>
                        <pagination :links="withdrawals.links" />
                    </div>
                </div>
                <div v-else class="flex flex-wrap justify-center text-2xl text-white">
                    {{ $t('No Entries') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '../../Components/Pagination';
import PageHeader from '../../Components/PageHeader';
import BtnLink from '../../Components/BtnLink';

export default {
    name: "Index",
    components: {BtnLink, PageHeader, Pagination},
    props: {
        withdrawals: Object,
    },
    metaInfo() {
        return {
            title: this.title
        }
    },
    computed: {
        title () {
            return this.$t('Withdrawals');
        }
    },
    methods: {
        showFormattedAmount(amount, currencyCode) {
            return this.$formatCurrency(amount, currencyCode);
        }
    }
}
</script>

<style lang="scss" scoped>
tr:nth-child(even) {
    background-color: #f4f5f7;
}
</style>
